import { brandsApi } from './brands.api';

const actionPrefix = (actionType) => `BrandsApi/${actionType}`;

export const SET_BRANDS = actionPrefix`SET_BRANDS`;
export const setBrands = (brands) => ({
  type: SET_BRANDS,
  payload: brands,
});

export const loadBrands = () => (dispatch) =>
  brandsApi.get().then(({ brands }) => {
    dispatch(setBrands(brands));
  });

export const brandsActions = {
  setBrands,
  loadBrands,
};
